export function normalizeSellingPlanId (id) {
  if (id == null || id === '') return ''
  const s = String(id)
  const match = /SellingPlan\/(\d+)/i.exec(s)
  if (match) return match[1]
  const n = Number(s)
  return Number.isFinite(n) ? String(n) : s
}

const normalizeSellingPlanName = name => String(name || '').trim().toLowerCase()

export const hasSellingPlan = plan => plan?.id != null && plan.id !== ''

export function sellingPlanIndex (allocations, plan) {
  const wanted = normalizeSellingPlanId(plan?.id)
  if (!wanted || !Array.isArray(allocations)) return -1

  return allocations.findIndex(allocation => normalizeSellingPlanId(allocation?.selling_plan_id) === wanted)
}

export function matchAllocation (allocations = [], plan, planIndex = -1) {
  const wantedName = normalizeSellingPlanName(plan?.name)

  return allocations[sellingPlanIndex(allocations, plan)] ||
    (wantedName && allocations.find(allocation => normalizeSellingPlanName(allocation?.selling_plan_name || allocation?.name) === wantedName)) ||
    allocations[planIndex] ||
    null
}
